<template>
  <div>
  	<div class="table_title">
  		<div class="selectBox">
  			<span>表格：</span>
  			<el-select v-model="value" placeholder="请选择" @change="change">
			    <el-option
			      v-for="item in options"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			  </el-select>
  		</div>
  		<h1>日阅通图书销售管理平台</h1>
  		<div class="selectBox">
  			<span>筛选来源：</span>
  			<el-select v-model="fromVal" placeholder="请选择" @change="changeFrom">
			    <el-option
			      v-for="item in fromOptions"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			  </el-select>
  		</div> 	
  		<div class="changePassBtn" @click="$router.push({path:'changePass'})">修改密码</div>
  		<div class="loginOut" @click="loginOut">
  			<img src="../assets/loginOut.png"/>
  			<span>退出</span>
  		</div>
  	</div> 	
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
 			options: [{
          value: '全部',
          label: '全部'
        }, {
          value: '人员',
          label: '人员'
        }],
        value: '全部',
        fromOptions:[{
        	value: '全部',
          label: '全部'
        }],
        fromVal:'全部'
    }
   },
   created:function(){
   	var _this=this;
   	if(_this.$route.name=='info'){
   		_this.value='全部'
   	}else{
   		_this.value='人员'
   	}
   	
   	_this.getOrderBuyFromList();
   },
    methods:{
    	change:function(val){
    		var _this=this;
    		if(val=='全部'){
    			_this.$router.push({name:'info',query:{val:encodeURIComponent(_this.fromVal)}})
    		}else{
    			_this.$router.push({name:'user',query:{val:encodeURIComponent(_this.fromVal)}})
    		}
    	},
    	changeFrom:function(val){
    		var _this=this;
    		if(_this.value=='全部'){
    			_this.$router.push({name:'info',query:{val:encodeURIComponent(val)}})
    		}else{
    			_this.$router.push({name:'user',query:{val:encodeURIComponent(val)}})
    		}
    	},
    	getOrderBuyFromList:function(){
    		var _this = this;
				$.ajax({
					type: "post",
					url: _this.$store.state.getUrl + "api/sell/getOrderBuyFromList",
					data: JSON.stringify({
						"token": _this.$store.getters.getStorage
					}),
					dataType: "json",
					crossDomain: true == !(document.all),
					contentType: "application/json",
					success: function(data) {
						if(data.ret == 10000) {
							//_this.fromOptions=data.result.list;
							for(var i in data.result.list){
								_this.fromOptions.push({value:data.result.list[i].buyFromName,label:data.result.list[i].buyFromName})
							}
							console.log(_this.fromOptions)
						}
					}
				});
    	},
	    loginOut:function(){
				var _this=this;
				_this.$confirm('是否退出登录', '提示', {
		      confirmButtonText: '确定',
		      cancelButtonText: '取消',
		      type: 'warning'
		    }).then(() => {
		      localStorage.clear();
		      window.location.reload();
		      //_this.$router.replace({name:'login'})
		    }).catch(() => {
		           
		    });
			},
    },
    mounted:function(){
    	var _this=this;	
    },
	beforeRouteEnter (to, from, next) {
    if (to.matched.some(m => m.meta.auth)) {
	    if (window.localStorage.isLogin === '1') {
	      next()
	    } else{
	      next({path: '/login'})
	      Vue.prototype.$message.warning('检测到您还未登录,请登录后操作！')
	    }
	  } else {
	    next()
	  }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue